import { render, staticRenderFns } from "./LobbyPage.vue?vue&type=template&id=a3843522&scoped=true&lang=pug&"
import script from "./LobbyPage.vue?vue&type=script&lang=ts&"
export * from "./LobbyPage.vue?vue&type=script&lang=ts&"
import style0 from "./LobbyPage.vue?vue&type=style&index=0&id=a3843522&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3843522",
  null
  
)

component.options.__file = "LobbyPage.vue"
export default component.exports